import { ApiClientResponse, routes, mediaModuleClient } from '../../../common/services';

import { MediaDataObject } from '../../data-objects';

export const deleteMedia = (mediaId: string) =>
  mediaModuleClient.delete<MediaDataObject, ApiClientResponse<MediaDataObject>>(routes.chatrooms.media.delete(mediaId));
